export default {
  api: {
    baseUrl: 'http://localhost:7000',
    chatUrl: 'http://localhost:7002',
  },
};
